import React, { useEffect, useState } from "react";
import * as c from "./lpBlockquoteSection.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

export default function LpBlockquoteSection({ author, company, quote, backgroundColor, photo }) {
  const [randomAngle, setRandomAngle] = useState(0);

  useEffect(() => {
    // Generate random angle in increments of 45 degrees (0, 45, 90, 135, 180, 225, 270, 315)
    const possibleAngles = Array.from({ length: 8 }, (_, i) => i * 45);
    const randomIndex = Math.floor(Math.random() * possibleAngles.length);
    setRandomAngle(possibleAngles[randomIndex]);
  }, []);

  return (
    <>
      <section className={classNames(c.container, c[backgroundColor?.name], "blockquote-section")}>
        <div
          className={c.wrapper}
          data-transition="slide-enter"
          style={{ "--block-quote-gradient-angle": `${randomAngle}deg` }}
        >
          <blockquote className={c.blockquote}>
            <p className={classNames(c.quote, "p1")}>{quote?.quote}</p>
            <footer>
              <figure className={c.citation}>
                {photo && <GatsbyImage image={getImage(photo)} className={c.photo} alt={author} />}
                <figcaption className={c.author}>
                  {author}
                  <cite className={c.company}>{company}</cite>
                </figcaption>
              </figure>
            </footer>
          </blockquote>
        </div>
      </section>
    </>
  );
}
